/**
 * Kept in its own leaf module (no imports) because `src/config.ts` needs the
 * enum. Importing it from GlobalModalContainer pulls the modal components — and
 * their `ducks/auth` -> `apis/authApi` -> `config` chain — into a circular
 * import, which leaves `config` undefined at module-eval time.
 */
export enum GlobalModalTypes {
  'Notifications',
  'Agenda',
  'Speakers',
  'EntrySelection',
  'Welcome',
  'Guide',
  'ComingSoon',
  'AttendanceNotice',
  'LogoutNotice',
}
